import React, {useState, useEffect, useContext} from "react";
import {Layout, Menu, notification} from "antd";
import {UserOutlined, SolutionOutlined, DatabaseOutlined, CarOutlined, MessageOutlined, CrownOutlined} from "@ant-design/icons";
import {Link, Route, Redirect} from "react-router-dom";
import i18n from "../../../i18n";
import {AppContext} from "../../../contexts/app-context";
import {companyService, userServices} from "../../../services";
import Error from "../../error";
import Spinner from "../../../components/spinner";
import Employee from "./employee";
import LegalEntities from "./legal-entities";
import OrdersToConsignor from './orders/orders-to-consignor';
import OrdersGosLog from './orders/orders-gos-log';
import EpdAstral from "./epd-astral";


import {
  COMPANY_DIRECTOR_PERMISSION,
    VIEW_AGREED_DELIVERIES_CARRIER,
  VIEW_COMPANY_PAGE,
  CREATE_COMPANY_PERSON
} from "../../../helpers/user_permission.helper";
import OrdersToShipperCompany from "./orders/orders-to-shipper-company";
import DistributionCentres from "../consignor-page/distribution-centres";
import CreateDelivery from "../consignor-page/create-delivery";
import SubscriptionPage from "../billing-page/subscription";
import UserNotification from "./user-notification";
import UserNotificationSettings from "./user-notification-settings";
import CarPark from "./car-park";
import UserProfileEditForm from "../../user-profile-edit-form";

function LeftMenu({collapsed, menuElementsData}) {
  const user = userServices.getUser();
  const menuElements = menuElementsData.map(menuItemData => {
    if (!user.isAccessTo(menuItemData.permission)) {
      return null;
    }

    if (menuItemData.subMenu) {
      const groupItems = menuItemData.items.map(item => {
        return (
          <Menu.Item key={item.key}>
            <Link to={item.link} onClick={()=>{setOpenCurrent(item.link)}}>{item.label}</Link>
          </Menu.Item>
        );
      });

      return (
        <Menu.SubMenu key={menuItemData.parentKey} title={menuItemData.label}>
          {groupItems}
        </Menu.SubMenu>
      );
    } else {
      return (
        <Menu.Item key={menuItemData.parentKey}>
          <Link to={menuItemData.link} onClick={()=>{setOpenCurrent(menuItemData.link)}}>{menuItemData.label}</Link>
        </Menu.Item>
      );
    }
  });
  const [openCurrent, setOpenCurrent] = useState(window.location.pathname);

  const menuSelectedItem = menuElementsData
    .filter(data => {
      if (data.subMenu) {
        const itemsLinks = data.items.filter(dataItem => {
          return dataItem.link === openCurrent;
        });

        return itemsLinks.length;
      } else {
        return data.link === openCurrent;
      }
    })
    .map(item => {
      if (item.subMenu) {
        const itemsLinks = item.items.filter(dataItem => {
          return dataItem.link === openCurrent;
        });

        return {parentKey: item.parentKey, itemKey: itemsLinks[0].key};
      } else {
        return {parentKey: item.parentKey, itemKey: item.parentKey};
      }
    })
    .shift();

  return (
    <Menu
      defaultSelectedKeys={typeof menuSelectedItem !== "undefined" ? [menuSelectedItem.itemKey] : []}
      defaultOpenKeys={typeof menuSelectedItem !== "undefined" ? [menuSelectedItem.parentKey] : []}
      selectedKeys={typeof menuSelectedItem !== "undefined" ? [menuSelectedItem.itemKey] : []}
      mode="inline"
      theme="light"
      inlineCollapsed={collapsed}
    >
      {menuElements}
    </Menu>
  );
}

export default function CompanyPage() {
  const user = userServices.getUser();

  if (user.isGuest()) {
    return <Error status={403} desc={i18n.t('main.status.403')}/>;
  }

  const [collapsed, setCollapsed] = useState(false);

  const [companyInfo, setCompanyInfo] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  const appContext = useContext(AppContext);

  const handleResize = () => {
    if (collapsed === false && window.innerWidth < 1000) {
      setCollapsed(true);
    } else if (collapsed === true && window.innerWidth > 1000) {
      setCollapsed(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  useEffect(() => {
    if (!dataLoaded) {
      companyService
        .getCompanyInfo()
        .then((response) => {
          setCompanyInfo(response);

          setDataLoaded(true);
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('components.notification.titles.getCompanyInfo'),
            description: err,
          });
        });
    }
  }, [dataLoaded]);

  var isDispatcher = companyInfo && companyInfo.Type && (companyInfo.Type.Alias === 'dispatcher' || companyInfo.Type.Alias === 'transport_company');

  const carrierElements = [
      {
        parentKey: "group1",
        link: "/company/legal-entities",
        label: (
          <span>
            <span className="icon-menu anticon anticon-solution" role="img">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.9554 7.84106L13.4347 3.33086C13.805 3.15366 14.0614 2.77533 14.0614 2.33817C14.0614 2.16547 13.9213 2.02542 13.7487 2.02542C13.576 2.02542 13.4359 2.16547 13.4359 2.33817C13.4359 2.59972 13.2231 2.81254 12.9615 2.81254C12.7 2.81254 12.4872 2.59972 12.4872 2.33817C12.4872 2.16547 12.3471 2.02542 12.1744 2.02542H9.31063C9.3911 1.84609 9.43623 1.64759 9.43623 1.43864C9.43623 0.645387 8.79084 0 7.99759 0C7.20434 0 6.55895 0.645387 6.55895 1.43864C6.55895 1.64759 6.60411 1.84606 6.68455 2.02542H3.82078C3.64808 2.02542 3.50803 2.16547 3.50803 2.33817C3.50803 2.59972 3.29521 2.81254 3.03366 2.81254C2.7721 2.81254 2.55928 2.59972 2.55928 2.33817C2.55928 2.16547 2.41923 2.02542 2.24653 2.02542C2.07383 2.02542 1.93378 2.16547 1.93378 2.33817C1.93378 2.77533 2.19017 3.15366 2.56047 3.33086L0.0397503 7.84106C0.0136984 7.88769 0 7.94023 0 7.99365C0 9.40774 1.15044 10.5582 2.56453 10.5582H3.50278C4.91687 10.5582 6.06731 9.40774 6.06731 7.99365C6.06731 7.94023 6.05361 7.88769 6.02756 7.84106L3.50681 3.33086C3.78509 3.19766 3.99908 2.95093 4.08821 2.65091H6.94297V13.6857H6.20282C5.09914 13.6857 4.20124 14.5836 4.20124 15.6873C4.20124 15.86 4.34129 16 4.51399 16H11.4987C11.6714 16 11.8114 15.86 11.8114 15.6873C11.8114 14.5836 10.9135 13.6857 9.80984 13.6857H9.06969V2.65091H11.9069C11.9961 2.95093 12.2101 3.19766 12.4883 3.33086L9.96759 7.84106C9.94154 7.88769 9.92784 7.94023 9.92784 7.99365C9.92784 9.40774 11.0783 10.5582 12.4924 10.5582H13.4306C14.8447 10.5582 15.9951 9.40774 15.9951 7.99365C15.9952 7.94023 15.9815 7.88769 15.9554 7.84106ZM3.03366 3.76633L5.22148 7.6809H0.845827L3.03366 3.76633ZM3.50278 9.93269H2.56453C1.60189 9.93269 0.801354 9.22729 0.651298 8.3064H5.41601C5.26596 9.22729 4.46542 9.93269 3.50278 9.93269ZM7.99759 0.625496C8.44598 0.625496 8.81074 0.990254 8.81074 1.43864C8.81074 1.88703 8.44598 2.25179 7.99759 2.25179C7.5492 2.25179 7.18445 1.88703 7.18445 1.43864C7.18445 0.990254 7.5492 0.625496 7.99759 0.625496ZM11.1501 15.3745H4.86261C5.00456 14.7659 5.55159 14.3112 6.20286 14.3112H9.80987C10.4611 14.3112 11.0081 14.7659 11.1501 15.3745ZM7.5685 13.6857V2.81189C7.70408 2.85433 7.84819 2.87728 7.99759 2.87728C8.1535 2.87728 8.30352 2.85201 8.44419 2.80594V13.6857H7.5685ZM15.1493 7.6809H10.7737L12.9615 3.76633L15.1493 7.6809ZM13.4307 9.93269H12.4924C11.5298 9.93269 10.7292 9.22729 10.5792 8.3064H15.3439C15.1938 9.22729 14.3933 9.93269 13.4307 9.93269Z" fill="#2B3F63" />
              </svg>
            </span>
            <span>{i18n.t('companyPage.menu.group1.title')}</span>
          </span>
        ),
        subMenu: false,
        items: [],
        permission: COMPANY_DIRECTOR_PERMISSION,
      },
      {
        parentKey: "group2",
        link: "/company/employee",
        label: (
          <span>
            <span className="icon-menu anticon anticon-solution" role="img">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.6569 10.3431C12.7855 9.47181 11.7484 8.82678 10.6168 8.43631C11.8288 7.60159 12.625 6.20463 12.625 4.625C12.625 2.07478 10.5502 0 8 0C5.44978 0 3.375 2.07478 3.375 4.625C3.375 6.20463 4.17122 7.60159 5.38319 8.43631C4.25163 8.82678 3.2145 9.47181 2.34316 10.3431C0.832156 11.8542 0 13.8631 0 16H1.25C1.25 12.278 4.27803 9.25 8 9.25C11.722 9.25 14.75 12.278 14.75 16H16C16 13.8631 15.1678 11.8542 13.6569 10.3431ZM8 8C6.13903 8 4.625 6.486 4.625 4.625C4.625 2.764 6.13903 1.25 8 1.25C9.86097 1.25 11.375 2.764 11.375 4.625C11.375 6.486 9.86097 8 8 8Z" fill="#2B3F63" />
              </svg>
            </span>
            <span>{i18n.t('companyPage.menu.group2.title')}</span>
          </span>
        ),
        subMenu: false,
        items: [],
        permission: CREATE_COMPANY_PERSON,
      },
      {
        parentKey: "group3",
        link: null,
        label: (
          <span>
            <span className="icon-menu anticon anticon-solution" role="img">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.000732422C3.5888 0.000732422 0 3.58939 0 8.0003C0 12.4113 3.5888 15.9999 8 15.9999C12.4112 15.9999 16 12.4113 16 8.0003C16 3.58939 12.4112 0.000732422 8 0.000732422ZM8 14.5454C4.39084 14.5454 1.45455 11.6093 1.45455 8.00034C1.45455 4.39138 4.39084 1.45528 8 1.45528C11.6092 1.45528 14.5455 4.39137 14.5455 8.0003C14.5455 11.6094 11.6092 14.5454 8 14.5454Z" fill="#2B3F63" />
                <path d="M7.99973 6.30347C7.59809 6.30347 7.27246 6.62909 7.27246 7.03074V11.8784C7.27246 12.28 7.59809 12.6057 7.99973 12.6057C8.40138 12.6057 8.72701 12.28 8.72701 11.8784V7.03074C8.72701 6.62914 8.40138 6.30347 7.99973 6.30347Z" fill="#2B3F63" />
                <path d="M7.99973 3.39441C7.80822 3.39441 7.62102 3.47198 7.48531 3.60726C7.35004 3.74253 7.27246 3.93017 7.27246 4.12168C7.27246 4.3132 7.35004 4.50035 7.48531 4.63611C7.62058 4.77138 7.80822 4.84895 7.99973 4.84895C8.19125 4.84895 8.3784 4.77138 8.51411 4.63611C8.64938 4.50035 8.72701 4.3132 8.72701 4.12168C8.72701 3.93017 8.64938 3.74253 8.51411 3.60726C8.3784 3.47194 8.19125 3.39441 7.99973 3.39441Z" fill="#2B3F63" />
              </svg>
            </span>
            <span>{i18n.t('companyPage.menu.group3.title')}</span>
          </span>
        ),
        subMenu: true,
        items: [
          {
            key: '1',
            link: '/company/orders-to-consignor',
            label: i18n.t('companyPage.menu.group3.items.1'),
          },
          ...(isDispatcher ? [{
            key: '2',
            link: '/company/orders-gos-log',
            label: 'Заявки ГосЛог',
          }] : []),
          {
            key: '3',
            link: '/company/orders-to-shipper-company',
            label: i18n.t('companyPage.menu.group3.items.2'),
          }
        ],
        permission: COMPANY_DIRECTOR_PERMISSION,
      },
      {
        parentKey: "group4",
        link: "/company/car-park",
        label: (
          <span>
            <span className="icon-menu anticon anticon-solution" role="img">
              <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 9.25C2.85166 9.25 2.70666 9.29399 2.58332 9.3764C2.45999 9.45881 2.36386 9.57594 2.30709 9.71299C2.25032 9.85003 2.23547 10.0008 2.26441 10.1463C2.29335 10.2918 2.36478 10.4254 2.46967 10.5303C2.57456 10.6352 2.7082 10.7067 2.85368 10.7356C2.99917 10.7645 3.14997 10.7497 3.28701 10.6929C3.42406 10.6361 3.54119 10.54 3.6236 10.4167C3.70601 10.2933 3.75 10.1483 3.75 10C3.74978 9.80116 3.67069 9.61052 3.53008 9.46992C3.38948 9.32931 3.19884 9.25022 3 9.25ZM3 10.25C2.95055 10.25 2.90222 10.2353 2.86111 10.2079C2.81999 10.1804 2.78795 10.1414 2.76903 10.0957C2.75011 10.05 2.74516 9.99972 2.7548 9.95123C2.76445 9.90273 2.78826 9.85819 2.82322 9.82322C2.85819 9.78826 2.90273 9.76445 2.95123 9.7548C2.99972 9.74516 3.04999 9.75011 3.09567 9.76903C3.14135 9.78795 3.1804 9.82 3.20787 9.86111C3.23534 9.90222 3.25 9.95056 3.25 10C3.24992 10.0663 3.22356 10.1298 3.17669 10.1767C3.12983 10.2236 3.06628 10.2499 3 10.25Z" fill="#2B3F63" />
                <path d="M12.5 9.25C12.3517 9.25 12.2067 9.29399 12.0833 9.3764C11.96 9.45881 11.8639 9.57594 11.8071 9.71299C11.7503 9.85003 11.7355 10.0008 11.7644 10.1463C11.7934 10.2918 11.8648 10.4254 11.9697 10.5303C12.0746 10.6352 12.2082 10.7067 12.3537 10.7356C12.4992 10.7645 12.65 10.7497 12.787 10.6929C12.9241 10.6361 13.0412 10.54 13.1236 10.4167C13.206 10.2933 13.25 10.1483 13.25 10C13.2498 9.80116 13.1707 9.61052 13.0301 9.46992C12.8895 9.32931 12.6988 9.25022 12.5 9.25ZM12.5 10.25C12.4506 10.25 12.4022 10.2353 12.3611 10.2079C12.32 10.1804 12.288 10.1414 12.269 10.0957C12.2501 10.05 12.2452 9.99972 12.2548 9.95123C12.2645 9.90273 12.2883 9.85819 12.3232 9.82322C12.3582 9.78826 12.4027 9.76445 12.4512 9.7548C12.4997 9.74516 12.55 9.75011 12.5957 9.76903C12.6414 9.78795 12.6804 9.82 12.7079 9.86111C12.7353 9.90222 12.75 9.95056 12.75 10C12.7499 10.0663 12.7236 10.1298 12.6767 10.1767C12.6298 10.2236 12.5663 10.2499 12.5 10.25Z" fill="#2B3F63" />
                <path d="M15.4603 5.86469L13.2103 2.36469C13.1877 2.32949 13.1565 2.30055 13.1198 2.28051C13.083 2.26048 13.0419 2.24998 13 2.25H10V0.875C9.99974 0.643014 9.90747 0.420604 9.74343 0.256565C9.5794 0.0925261 9.35699 0.000256416 9.125 0H0.875C0.643014 0.000256416 0.420604 0.0925261 0.256565 0.256565C0.092526 0.420604 0.000256416 0.643014 0 0.875V10C0 10.0663 0.0263392 10.1299 0.0732233 10.1768C0.120107 10.2237 0.183696 10.25 0.25 10.25H1.26813C1.32822 10.6665 1.53638 11.0473 1.85445 11.3228C2.17253 11.5983 2.57922 11.7499 3 11.7499C3.42078 11.7499 3.82747 11.5983 4.14555 11.3228C4.46362 11.0473 4.67178 10.6665 4.73187 10.25H10.7681C10.8282 10.6665 11.0364 11.0473 11.3545 11.3228C11.6725 11.5983 12.0792 11.7499 12.5 11.7499C12.9208 11.7499 13.3275 11.5983 13.6455 11.3228C13.9636 11.0473 14.1718 10.6665 14.2319 10.25H15.25C15.3163 10.25 15.3799 10.2237 15.4268 10.1768C15.4737 10.1299 15.5 10.0663 15.5 10V6C15.5 5.95203 15.4862 5.90506 15.4603 5.86469ZM3 11.25C2.75277 11.25 2.5111 11.1767 2.30554 11.0393C2.09998 10.902 1.93976 10.7068 1.84515 10.4784C1.75054 10.2499 1.72579 9.99861 1.77402 9.75614C1.82225 9.51366 1.9413 9.29093 2.11612 9.11612C2.29093 8.9413 2.51366 8.82225 2.75614 8.77402C2.99861 8.72579 3.24995 8.75054 3.47835 8.84515C3.70676 8.93976 3.90199 9.09998 4.03934 9.30554C4.17669 9.5111 4.25 9.75277 4.25 10C4.24967 10.3314 4.11787 10.6492 3.88352 10.8835C3.64917 11.1179 3.33142 11.2497 3 11.25ZM9.5 9.75H4.73187C4.67178 9.33353 4.46362 8.95267 4.14555 8.67719C3.82747 8.40172 3.42078 8.25009 3 8.25009C2.57922 8.25009 2.17253 8.40172 1.85445 8.67719C1.53638 8.95267 1.32822 9.33353 1.26813 9.75H0.5V7.25H9.5V9.75ZM9.5 6.75H0.5V0.875C0.500083 0.775569 0.539618 0.680235 0.609926 0.609926C0.680235 0.539618 0.775569 0.500083 0.875 0.5H9.125C9.22443 0.500083 9.31977 0.539618 9.39007 0.609926C9.46038 0.680235 9.49992 0.775569 9.5 0.875V6.75ZM13.3456 3.5L14.7922 5.75H11.25V3.5H13.3456ZM12.5 11.25C12.2528 11.25 12.0111 11.1767 11.8055 11.0393C11.6 10.902 11.4398 10.7068 11.3452 10.4784C11.2505 10.2499 11.2258 9.99861 11.274 9.75614C11.3222 9.51366 11.4413 9.29093 11.6161 9.11612C11.7909 8.9413 12.0137 8.82225 12.2561 8.77402C12.4986 8.72579 12.7499 8.75054 12.9784 8.84515C13.2068 8.93976 13.402 9.09998 13.5393 9.30554C13.6767 9.5111 13.75 9.75277 13.75 10C13.7497 10.3314 13.6179 10.6492 13.3835 10.8835C13.1492 11.1179 12.8314 11.2497 12.5 11.25ZM15 7.75H14.5C14.4337 7.75 14.3701 7.72366 14.3232 7.67678C14.2763 7.62989 14.25 7.5663 14.25 7.5C14.25 7.4337 14.2763 7.37011 14.3232 7.32322C14.3701 7.27634 14.4337 7.25 14.5 7.25H15V7.75ZM15 6.75H14.5C14.3011 6.75 14.1103 6.82902 13.9697 6.96967C13.829 7.11032 13.75 7.30109 13.75 7.5C13.75 7.69891 13.829 7.88968 13.9697 8.03033C14.1103 8.17098 14.3011 8.25 14.5 8.25H15V9.75H14.2319C14.1718 9.33353 13.9636 8.95267 13.6455 8.67719C13.3275 8.40172 12.9208 8.25009 12.5 8.25009C12.0792 8.25009 11.6725 8.40172 11.3545 8.67719C11.0364 8.95267 10.8282 9.33353 10.7681 9.75H10V2.75H12.8634L13.0244 3H11C10.9337 3 10.8701 3.02634 10.8232 3.07322C10.7763 3.12011 10.75 3.1837 10.75 3.25V6C10.75 6.0663 10.7763 6.12989 10.8232 6.17678C10.8701 6.22366 10.9337 6.25 11 6.25H15V6.75Z" fill="#2B3F63" />
                <path d="M11.75 6.75H11C10.9337 6.75 10.8701 6.77634 10.8232 6.82322C10.7763 6.87011 10.75 6.9337 10.75 7C10.75 7.0663 10.7763 7.12989 10.8232 7.17678C10.8701 7.22366 10.9337 7.25 11 7.25H11.75C11.8163 7.25 11.8799 7.22366 11.9268 7.17678C11.9737 7.12989 12 7.0663 12 7C12 6.9337 11.9737 6.87011 11.9268 6.82322C11.8799 6.77634 11.8163 6.75 11.75 6.75Z" fill="#2B3F63" />
                <path d="M6.5 8.25H8.5C8.5663 8.25 8.62989 8.22366 8.67678 8.17678C8.72366 8.12989 8.75 8.0663 8.75 8C8.75 7.9337 8.72366 7.87011 8.67678 7.82322C8.62989 7.77634 8.5663 7.75 8.5 7.75H6.5C6.4337 7.75 6.37011 7.77634 6.32322 7.82322C6.27634 7.87011 6.25 7.9337 6.25 8C6.25 8.0663 6.27634 8.12989 6.32322 8.17678C6.37011 8.22366 6.4337 8.25 6.5 8.25Z" fill="#2B3F63" />
                <path d="M8.5 8.5H7.75C7.6837 8.5 7.62011 8.52634 7.57322 8.57322C7.52634 8.62011 7.5 8.6837 7.5 8.75C7.5 8.8163 7.52634 8.87989 7.57322 8.92678C7.62011 8.97366 7.6837 9 7.75 9H8.5C8.5663 9 8.62989 8.97366 8.67678 8.92678C8.72366 8.87989 8.75 8.8163 8.75 8.75C8.75 8.6837 8.72366 8.62011 8.67678 8.57322C8.62989 8.52634 8.5663 8.5 8.5 8.5Z" fill="#2B3F63" />
              </svg>
            </span>
            <span>{i18n.t('companyPage.menu.group4.title')}</span>
          </span>
        ),
        permission: VIEW_COMPANY_PAGE,
      },
      {
        parentKey: "group5",
        link: "/company/user-notification",
        label: (
          <span>
             <MessageOutlined/>
            <span>{i18n.t('companyPage.menu.group5.title')}</span>
          </span>
        ),
        permission: VIEW_COMPANY_PAGE,
      },
      {
        parentKey: "group6",
        link: "/company/user-edit-profile",
        label: (
          <span>
                  <UserOutlined/>
                  <span>{i18n.t('companyPage.menu.group6.title')}</span>
              </span>
        ),
        permission: VIEW_COMPANY_PAGE,
      },
      {
        parentKey: "group7",
        link: "/company/epd-astral",
        label: (
          <span>
              <UserOutlined/>
              <span>{i18n.t('companyPage.menu.group9.title')}</span>
          </span>
        ),
        permission: COMPANY_DIRECTOR_PERMISSION,
      }
    ];

  const subscriptionElements = [
      {
        parentKey: "group8",
        link: "/company/subscription",
        label: (
          <span>
            <CrownOutlined/>
            <span>{i18n.t('companyPage.menu.subscription.title')}</span>
          </span>
        ),
        permission: VIEW_COMPANY_PAGE,
      }
  ]

  const menuElements = {
    carrier: carrierElements,
    carrier_consignor: carrierElements.concat(subscriptionElements),
    transport_company: carrierElements,
    dispatcher: carrierElements,
    dispatcher_consignor: carrierElements.concat(subscriptionElements),
    consignor: [
      {
        parentKey: "group1",
        link: "/company/legal-entities",
        label: (
          <span>
            <SolutionOutlined/>
            <span>{i18n.t('companyPage.menu.group1.title')}</span>
          </span>
        ),
        subMenu: false,
        items: [],
        permission: COMPANY_DIRECTOR_PERMISSION,
      },
      {
        parentKey: "group2",
        link: "/company/employee",
        label: (
          <span>
            <UserOutlined/>
            <span>{i18n.t('companyPage.menu.group2.title')}</span>
          </span>
        ),
        subMenu: false,
        items: [],
        permission: CREATE_COMPANY_PERSON,
      },
      {
        parentKey: "group3",
        link: null,
        label: (
          <span>
            <SolutionOutlined/>
            <span>{i18n.t('companyPage.menu.group3.title')}</span>
          </span>
        ),
        subMenu: true,
        items: [
          {
            key: '1',
            link: '/company/orders-to-consignor',
            label: i18n.t('companyPage.menu.group3.items.1'),
          },
          ...(isDispatcher ? [{
            key: '2',
            link: '/company/orders-gos-log',
            label: 'Заявки ГосЛог',
          }] : []),
          {
            key: '3',
            link: '/company/orders-to-shipper-company',
            label: i18n.t('companyPage.menu.group3.items.2'),
          }
        ],
        permission: COMPANY_DIRECTOR_PERMISSION,
      },
      {
        parentKey: "group6",
        link: "/company/user-edit-profile",
        label: (
          <span>
                  <UserOutlined/>
                  <span>{i18n.t('companyPage.menu.group6.title')}</span>
              </span>
        ),
        permission: VIEW_COMPANY_PAGE,
      }
    ],
    new: [
      {
        parentKey: "group1",
        link: "/company/legal-entities",
        label: (
          <span>
            <SolutionOutlined/>
            <span>{i18n.t('companyPage.menu.group1.title')}</span>
          </span>
        ),
        subMenu: false,
        items: [],
        permission: COMPANY_DIRECTOR_PERMISSION,
      },
      {
        parentKey: "group2",
        link: "/company/employee",
        label: (
          <span>
            <UserOutlined/>
            <span>{i18n.t('companyPage.menu.group2.title')}</span>
          </span>
        ),
        subMenu: false,
        items: [],
        permission: CREATE_COMPANY_PERSON,
      },
      {
        parentKey: "group3",
        link: null,
        label: (
          <span>
            <SolutionOutlined/>
            <span>{i18n.t('companyPage.menu.group3.title')}</span>
          </span>
        ),
        subMenu: true,
        items: [
          {
            key: '1',
            link: '/company/orders-to-consignor',
            label: i18n.t('companyPage.menu.group3.items.1'),
          },
          {
            key: '2',
            link: '/company/orders-gos-log',
            label: 'Заявки ГосЛог',
          },
          {
            key: '3',
            link: '/company/orders-to-shipper-company',
            label: i18n.t('companyPage.menu.group3.items.2'),
          }
        ],
        permission: COMPANY_DIRECTOR_PERMISSION,
      },
    ]
  };

  handleResize();

  if (appContext.filter.enable) {
    appContext.disableFilter();
  }

  if (!user.isAccessTo(VIEW_COMPANY_PAGE)) {
    return <Error status={403} desc={i18n.t('main.status.403')}/>;
  }

  if (window.location.pathname === "/company") {
    return <Redirect to="/company/car-park"/>;
  }

  if (!dataLoaded) {
    return <Spinner loading={true} tip={i18n.t('main.loadText.loading')}/>;
  }


  return (
    <Spinner loading={!dataLoaded} tip={i18n.t('main.loadText.loading')}>
      <Layout
        tagName="section"
        style={{
          marginTop: "50px",
          padding: "25px 0",
          background: "#fff",
          borderRadius: "11px",
          boxShadow: "0px 4px 10px rgba(130, 137, 147, 0.2)"
        }}
      >
        <Layout.Sider collapsed={collapsed} theme="light" width={293}>
          <LeftMenu collapsed={collapsed} menuElementsData={menuElements[companyInfo.Type.Alias]}/>
        </Layout.Sider>
        <Layout.Content style={{padding: "0 24px", minHeight: 350}} className="table-window">
          <Route path="/company/legal-entities" exact component={LegalEntities}/>
          <Route path="/company/employee" exact component={Employee}/>
          <Route path="/company/orders-to-consignor" exact component={OrdersToConsignor}/>
          <Route path="/company/orders-gos-log" exact component={OrdersGosLog}/>
          <Route path="/company/orders-to-shipper-company" exact component={OrdersToShipperCompany}/>
          <Route path="/company/distribution-centres"
                 render={(props) => <DistributionCentres consignorSettings={null} {...props} />}/>
          <Route path="/company/car-park" exact component={CarPark}/>
          <Route path="/company/create-delivery" exact component={CreateDelivery}/>
          <Route path="/company/user-notification" exact component={UserNotification}/>
          <Route path="/company/user-notification-settings" exact component={UserNotificationSettings}/>
          <Route path="/company/user-edit-profile" exact component={UserProfileEditForm}/>
          <Route path="/company/epd-astral" exact component={EpdAstral}/>
          <Route path="/company/subscription" exact component={SubscriptionPage}/>
        </Layout.Content>
      </Layout>
    </Spinner>
  );
}
